import { Box } from "@mui/system";
import DownloadButton from "../Common/DownloadButton";
import img from "../../Assets/babyFoodmobile.png";
import { Treemap } from "@antv/g2plot";
import { useEffect } from "react";

const TreeMapMobileChart = (props) => {
  const data = {
    children: [
      {
        name: "Baby foods other than \n processed cereal-based foods \n\n577",
        value: 577,
      },
      {
        name: "Processed cereal-based\nfoods for infants\n and young children\n\n187",
        value: 187,
      },
      { name: "Infant\n formulae\n\n390", value: 390 },
      { name: "Food for\ninfants and\nyoung\nchildren\n\n116", value: 116 },
      { name: "Follow-on\n formulae\n\n234", value: 234 },
    ],
  };
  useEffect(() => {
    const treemapPlot = new Treemap(document.getElementById("treeMapMobile"), {
      data,
      legend: false,
      tooltip: {
        customContent: (title, items) => {
          // Custom tooltip content
          return `<div  
          style="white-space: nowrap; left: 397.5px; top: 185px; padding: 16px;">
            <div >
              <div >
                  <div>
                  ${items
                    .map((item) => {
                      const temp = item.name.split(" ");
                      temp.splice(-1);
                      return `<div class="tooltipWrapper" style="overflow-wrap: break-word;">
                  <span id="repCountrytooltip"><b>${temp.join(" ")}</b>
                  </span>
                  <br>
                  <span id="repCountrytooltip2" 
                  style="color: rgb(34, 41, 77); padding-bottom: 0px; font-size: 12px;">Number of samples: ${
                    item.value
                  } </span>
              </div>`;
                    })
                    .join("")}
                  
              </div>
          </div>
          </div>
          </div>`;
        },
      },
      colorField: "#38b292",
      label: {
        type: "",
        formatter: (item) => {
          return item.name; // Display the name as label (adjust as needed)
        },
        style: {
          fill: "#22294d", // Change the label text color
          fontSize: 11, // Change the label font size
          fontWeight: 700,
          fontFamily: "Roboto Condensed-Bold, Roboto Condensed",
        },
      },
    });

    treemapPlot.render();

    return () => {
      treemapPlot.destroy();
    };
  }, []);
  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Box
        display="flex"
        justifyContent={{ xs: "flex-start", md: "space-between" }}
        sx={{ paddingRight: { xs: "40px", sm: "30px", md: "0px" } }}
      >
        <p style={{ marginBottom: "1.1rem", paddingRight: "10px" }}>
          {props.title}
        </p>
        <DownloadButton fileName={props.title} imageAsset={img} />
      </Box>

      {/* <svg xmlns="http://www.w3.org/2000/svg" width="306" height="838" viewBox="0 0 306 838">
  <g id="Group_3742" data-name="Group 3742" transform="translate(2820 -2630)">
    <g id="Rectangle_11395" data-name="Rectangle 11395" transform="translate(-2820 2630)" fill="#38b292" stroke="#fff" stroke-width="3">
      <rect width="306" height="527" stroke="none"/>
      <rect x="1.5" y="1.5" width="303" height="524" fill="none"/>
    </g>
    <g id="Rectangle_11396" data-name="Rectangle 11396" transform="translate(-2820 3155)" fill="#38b292" stroke="#fff" stroke-width="3">
      <rect width="192" height="198" stroke="none"/>
      <rect x="1.5" y="1.5" width="189" height="195" fill="none"/>
    </g>
    <g id="Rectangle_11397" data-name="Rectangle 11397" transform="translate(-2631 3155)" fill="#38b292" stroke="#fff" stroke-width="3">
      <rect width="117" height="198" stroke="none"/>
      <rect x="1.5" y="1.5" width="114" height="195" fill="none"/>
    </g>
    <g id="Rectangle_11398" data-name="Rectangle 11398" transform="translate(-2670 3351)" fill="#38b292" stroke="#fff" stroke-width="3">
      <rect width="156" height="117" stroke="none"/>
      <rect x="1.5" y="1.5" width="153" height="114" fill="none"/>
    </g>
    <g id="Rectangle_11399" data-name="Rectangle 11399" transform="translate(-2820 3351)" fill="#38b292" stroke="#fff" stroke-width="3">
      <rect width="153" height="117" stroke="none"/>
      <rect x="1.5" y="1.5" width="150" height="114" fill="none"/>
    </g>
    <text id="Follow-on_formulae" data-name="Follow-on
formulae" transform="translate(-2531 3377.5)" fill="#22294d" font-size="12" font-family="RobotoCondensed-Bold, Roboto Condensed" font-weight="700"><tspan x="-47.402" y="0">Follow-on</tspan><tspan x="-43.102" y="16">formulae</tspan></text>
    <text id="_117" data-name="117" transform="translate(-2531 3429.434)" fill="#22294d" font-size="34" font-family="RobotoCondensed-Bold, Roboto Condensed" font-weight="700"><tspan x="-51.598" y="0">117</tspan></text>
    <text id="Food_for_infants_and_young_children" data-name="Food for infants and young children" transform="translate(-2793.5 3364.5)" fill="#22294d" font-size="12" font-family="RobotoCondensed-Bold, Roboto Condensed" font-weight="700"><tspan x="9.297" y="13">Food for infants and </tspan><tspan x="35.014" y="29">young children</tspan></text>
    <text id="_118" data-name="118" transform="translate(-2687.5 3429.434)" fill="#22294d" font-size="34" font-family="RobotoCondensed-Bold, Roboto Condensed" font-weight="700"><tspan x="-51.598" y="0">118</tspan></text>
    <text id="Infant_formulae" data-name="Infant 
formulae" transform="translate(-2531 3183.5)" fill="#22294d" font-size="12" font-family="RobotoCondensed-Bold, Roboto Condensed" font-weight="700"><tspan x="-31.09" y="0">Infant </tspan><tspan x="-43.102" y="16">formulae</tspan></text>
    <text id="_147" data-name="147" transform="translate(-2531 3235.434)" fill="#22294d" font-size="34" font-family="RobotoCondensed-Bold, Roboto Condensed" font-weight="700"><tspan x="-51.598" y="0">147</tspan></text>
    <text id="Processed_cereal-based_foods_for_infants_and_young_children" data-name="Processed cereal-based foods 
for infants and young children" transform="translate(-2719 3183.5)" fill="#22294d" font-size="12" font-family="RobotoCondensed-Bold, Roboto Condensed" font-weight="700"><tspan x="-74.361" y="0">Processed cereal-based foods </tspan><tspan x="-72.108" y="16">for infants and young children</tspan></text>
    <text id="_259" data-name="259" transform="translate(-2645 3235.434)" fill="#22294d" font-size="34" font-family="RobotoCondensed-Bold, Roboto Condensed" font-weight="700"><tspan x="-51.598" y="0">259</tspan></text>
    <text id="Baby_foods_other_than_processed_cereal-based_foods" data-name="Baby foods other than
processed cereal-based foods" transform="translate(-2531 2661.934)" fill="#22294d" font-size="12" font-family="RobotoCondensed-Bold, Roboto Condensed" font-weight="700"><tspan x="-105.674" y="0">Baby foods other than</tspan><tspan x="-145.072" y="16">processed cereal-based foods</tspan></text>
    <text id="_1_142" data-name="1,142" transform="translate(-2531 2713.467)" fill="#22294d" font-size="34" font-family="RobotoCondensed-Bold, Roboto Condensed" font-weight="700"><tspan x="-77.147" y="0">1,142</tspan></text>
  </g>
      </svg> */}
      <div id="treeMapMobile"></div>
    </Box>
  );
};

export default TreeMapMobileChart;
